import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import StatusBadgeCst from "@components/StatusBadgeCst";
import {
  UserListItem,
  getUserDisplayName,
  getUserId,
} from "../../../hooks/useUsersList";

interface UserRowProps {
  user: UserListItem;
}

const UserRow: React.FC<UserRowProps> = ({ user }) => {
  const theme = useTheme();
  const id = getUserId(user);
  const isActive = (user.status || "").toLowerCase() === "active";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        minWidth: 0,
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: theme.palette.text.primary,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {getUserDisplayName(user)}
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            color: theme.palette.text.tertiary,
            lineHeight: 1.4,
          }}
        >
          {`ID: ${id}${user.email ? ` | ${user.email}` : ""}`}
        </Typography>
      </Box>

      {isActive && <StatusBadgeCst label="Attivo" variant="active" />}
    </Box>
  );
};

export default UserRow;
